import { generateBindings, view, View } from '@esui/core';
import { spread } from '@esui/core/utils/spread.js';
import '@material/mwc-top-app-bar';
import { html } from 'lit';

export const [TopAppBar] = view('esui-mwc-top-app-bar', {
  Props: class {
    centerTitle = false;
    dense = false;
    prominent = false;
    title: View | string = '';
    navigationIcon?: View = undefined;
    actionItems: View[] = [];
    content: View[] = [];
    scrollTarget?: HTMLElement | Window = undefined;
  },

  mapBuilder:
    TopAppBarBuilder =>
    (...content: View[]) =>
      TopAppBarBuilder().content(content),

  template(props) {
    const computedProps = generateBindings(props, [
      'content',
      'navigationIcon',
      'title',
      'actionItems',
    ]);

    return html`
      <mwc-top-app-bar ${spread(computedProps)}>
        ${props.navigationIcon?.slot('navigationIcon').body}
        ${typeof props.title === 'string'
          ? html` <div slot="title">${props.title}</div>`
          : props.title.slot('title').body}
        ${props.content?.map(el => el.body)}
        ${props.actionItems.map(el => el.slot('actionItems').body)}
      </mwc-top-app-bar>
    `;
  },
});
